import { breakpoint } from '@notonthehighstreet/toolkit/utils';

export const mediaQuery = device => `@media (min-width: ${breakpoint(device)}px)`;

export const fontFamily = 'NOTHS2, Helvetica Neue, HelveticaNeue, Arial, sans-serif';
